"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _package = _interopRequireDefault(require("@widget-editor/core/package.json"));

var _package2 = _interopRequireDefault(require("@widget-editor/widget-editor/package.json"));

var _package3 = _interopRequireDefault(require("@widget-editor/renderer/package.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ws_meta = {
  core: _package["default"].version,
  editor: _package2["default"].version,
  renderer: _package3["default"].version
};

var getEditorMeta = function getEditorMeta() {
  var adapter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var advanced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return _objectSpread({}, ws_meta, {
    adapter: adapter,
    advanced: advanced
  });
};

var _default = getEditorMeta;
exports["default"] = _default;